import { useEffect, useState } from "react"
import { format, parse, isValid } from "date-fns";
import { CouncilMeetingType } from "../../../../static/types/limited-company-creation/councilMeetingType";
import useValidation from "../../../../hooks/useValidation";
import councilMeetingValidationSchema from "../../../../utils/validation/limited-company-creation/councilMeetingValidationSchema";
import useAppContext from "../../../../hooks/useAppContext";
import { AppContextType } from "../../../../context/AppContext";


type statusSignatureProps = {
    checked: boolean,
    councilMeeting: CouncilMeetingType,
    changeCouncilMeeting: ( councilMeeting: Partial<CouncilMeetingType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function CouncilMeeting ({
    checked,
    councilMeeting,
    changeCouncilMeeting,
    onValidationChange
}: statusSignatureProps ) {
    
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const { errors, isValid: isDataValid } = useValidation( councilMeeting, councilMeetingValidationSchema )

    useEffect( () => {
        onValidationChange( isDataValid )

        let draft = parseDraft()
        const tempDraft = { ...draft, councilMeeting }
        setDraftFormData( stringifyDraft( tempDraft ))

    }, [ isDataValid, onValidationChange ])

    const [selectedDate, setSelectedDate] = useState<string>("");

    useEffect(() => {
        if ( councilMeeting.meetingDate ) {
            const parsedDate = parse(councilMeeting.meetingDate, "dd/MM/yyyy", new Date());
            if (isValid(parsedDate)) {
                    setSelectedDate(format(parsedDate, "yyyy-MM-dd"));
            } else {
                    setSelectedDate("");
            }
        }
    }, [ councilMeeting ]);
    
    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        if (inputDate) {
            const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
            const formattedDate = format(parsedDate, "dd/MM/yyyy");
    
            setSelectedDate(inputDate);
            changeCouncilMeeting({ meetingDate: formattedDate });
        } else {
            setSelectedDate("");
            changeCouncilMeeting({ meetingDate: "" });
        }
    };

    const openDatePicker = (id: string = "date") => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return(
        <div className="mb-3 row">

            <label htmlFor="meetingDateSCOPSA" className="col-sm-2 col-form-label">Date du CA <strong className="text-danger">*</strong> </label>

            <div className="col-sm-10 mb-3">
                <input
                    className = { `description-input form-control ${ ( checked && errors.meetingDate ) ? 'is-invalid' : ''}` }
                    type = "date"
                    id = "meetingDateSCOPSA"
                    value = { selectedDate }
                    onChange = { handleDateChange }
                    placeholder="JJ/MM/AAAA"
                    onClick={ () => openDatePicker("meetingDateSCOPSA") }
                />
                
                {  ( checked && errors.meetingDate ) && <div className="invalid-feedback"> { errors.meetingDate } </div> }
            </div>

        </div>
    )
}